<div class="assistant-shell">
  <div class="assistant-header">
    <div>
      <p class="label">Ruralx Mitra</p>
      <h6>How can I help today?</h6>
    </div>
    <button type="button" class="close-btn" aria-label="Close" (click)="close()">✕</button>
  </div>

  <div class="assistant-body">
    <div class="message-list" *ngIf="messages.length; else emptyState">
      <div *ngFor="let msg of messages" [ngClass]="msg.sender === 'ai' ? 'ai-msg' : 'user-msg'">
        {{ msg.text }}
      </div>
    </div>

    <ng-template #emptyState>
      <div class="empty-state">
        <p>Tap start to begin voice assistance for products, categories, or offers.</p>
      </div>
    </ng-template>
  </div>

  <div class="assistant-footer">
    <button mat-flat-button color="primary" class="start-btn" (click)="startConversation()">
      Start conversation
    </button>

    <div class="status" *ngIf="isListening" aria-live="polite">
      <span>Listening...</span>
      <span class="listening-bubble" aria-label="Listening">
        <span class="pulse-ring"></span>
      </span>
    </div>
  </div>
</div>
